import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavItem } from '../../types';
// import { ReactComponent as LogoSvg } from '../../logo_black.svg';
// import { ReactComponent as LogoSvg } from '../../logo_beige.svg';


const LogoSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="30 90 240 100"
    style={{ height: '30px', marginRight: '0rem', overflow: 'hidden' }}
  >
    <polygon
      points="238.17 115.96 143.12 130.42 136.57 174.17 149.47 137.95 238.17 115.96"
      fill="#f0f0f0"
    />
    <polygon
      points="126.2 138.41 37.29 159.87 134.69 145.05 141.24 101.3 126.2 138.41"
      fill="#f0f0f0"
    />
  </svg>
);


const HeaderContainer = styled.header<{ mobileOpen?: boolean }>`
  max-width: 1200px;
  width: 90%;
  margin: 2rem auto 0 auto;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  background-color: #13182a;

  box-shadow: ${(props) => (props.mobileOpen ? 'none' : '0 4px 10px rgba(0, 0, 0, 0.25)')};
  border-bottom: ${(props) => (props.mobileOpen ? '1px solid #f0f0f0' : 'none')};
  width: ${(props) => (props.mobileOpen ? '90%' : '90%')};
  max-width: ${(props) => (props.mobileOpen ? '90%' : '1200px')};

`;

const HeaderContent = styled.div`
  display: flex;
  margin: 0 auto;
  padding: 1rem;
  justify-content: space-between;2rem;
  align-items: center;
  position: relative;
  
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
  color: #f0f0f0;
  fill: #f0f0f0;
  font-family: 'Garamond';
  letter-spacing: 0.5px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const NavLink = styled.div<{ active: boolean }>`
  text-decoration: none;
  background-color: #13182a;
  color: #f0f0f0;
  font-weight: ${(props) => (props.active ? '400' : '400')};
  font-family: 'Garamond';
  position: relative;
  cursor: pointer;
  text-transform: uppercase;

  &:after {
    content: '';
    position: absolute;
    width: ${(props) => (props.active ? '100%' : '0')};
    height: 1px;
    bottom: -4px;
    left: 0;
    background-color: #f0f0f0;
    transition: width 0.3s ease;

  }

  &:hover:after {
    width: 100%;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
  font-size: 1.5rem;
  color: #f0f0f0;
  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileNav = styled.nav<{ open: boolean }>`
  display: flex;
  gap: 2rem;
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #13182a;
    box-shadow: none;
    display: ${(props) => (props.open ? 'flex' : 'none')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    z-index: 1000;
    font-family: 'Garamond';
    font-size: 1.5rem;
    font-weight: 150;
    padding: 2rem; /* Add padding to avoid content touching edges */
  }
`;

const CloseButton = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: #f0f0f0;
  cursor: pointer;
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const navItems: NavItem[] = [
    // { label: 'About Us', path: '/about', active: location.pathname === '/about' },
    {
      label: 'Philosophy',
      path: '/philosophy',
      active: location.pathname === '/philosophy',
    },
    // {
    //   label: 'Strategy & Edge',
    //   path: '/strategy',
    //   active: location.pathname === '/strategy',
    // },
    // { label: 'Founders', path: '/founders', active: location.pathname === '/founders' },
    {
      label: 'Contact',
      path: '/contact',
      active: location.pathname === '/contact',
    },
  ];

  return (
    <HeaderContainer mobileOpen={mobileOpen}>

      <HeaderContent>
        <Logo onClick={() => navigate('/')}>
          <LogoSvg
            style={{
              height: '30px',
              marginRight: '0rem',
              overflow: 'hidden',
              fill: '#f0f0f0',
              color: '#f0f0f0',
            }}
            viewBox="30 90 240 100" // 10% from sides (30,240) and 25% from top/bottom (75,150)
          />
          HEAVISIDE
        </Logo>
        <Hamburger onClick={() => setMobileOpen(!mobileOpen)}>≡</Hamburger>
        <MobileNav open={mobileOpen}>
          {mobileOpen && (
            <HeaderContainer mobileOpen={mobileOpen} style={{ position: 'absolute', top: '0rem' }}>
              <HeaderContent>
                <Logo onClick={() => navigate('/')}>
                  <LogoSvg
                    style={{
                      height: '30px',
                      marginRight: '0rem',
                      overflow: 'hidden',
                    }}
                    viewBox="30 90 240 100"
                  />
                  HEAVISIDE
                </Logo>
                <CloseButton onClick={() => setMobileOpen(false)}>
                  ×
                </CloseButton>
              </HeaderContent>
            </HeaderContainer>
          )}
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              active={item.active}
              onClick={() => {
                navigate(item.path);
                setMobileOpen(false);
              }}
            >
              {item.label}
            </NavLink>
          ))}
        </MobileNav>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
